import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectDestructuringEmpty from "@babel/runtime-corejs3/helpers/esm/objectDestructuringEmpty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { DocumentTitleSelectors } from '@spm/core';
import DocumentTitleManager from './DocumentTitleManager';
/**
 * Document title setting container component. Register aria live region with to screen readers.
 */
var DocumentTitleManagerContainer = function DocumentTitleManagerContainer(_ref) {
  var otherProps = _Object$assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var documentTitle = useSelector(function (state) {
    return DocumentTitleSelectors.getDocumentTitle(state);
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-atomic": "true",
    "aria-live": "polite",
    "aria-relevant": "additions",
    className: "wds-u-sr-only"
  }, otherProps), /*#__PURE__*/React.createElement(DocumentTitleManager, {
    documentTitle: documentTitle
  }));
};
DocumentTitleManagerContainer.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
DocumentTitleManagerContainer.defaultProps = {};
export default DocumentTitleManagerContainer;